module.exports = __webpack_public_path__ + "img/JPY.7d3562a5.svg";